@if (loadingService.loading) {
  <div class="transparent-overlay">
    <mat-progress-spinner data-viz-spinner
      class=""
      [color]="color"
      [mode]="mode"
      [value]=value
      diameter=100>
    </mat-progress-spinner>
  </div>
}